<div
    (mouseenter)="handleHealthScoreMouseEnter()"
    (mouseleave)="handleHealthScoreMouseLeave()"
    (onPositionChange)="handleSignpostConnectedPosition($event)"
    [hideOnMouseLeave]="false"
    [positionsPriority]="signpostPositionPriorities"
    [tooltipControl$]="signpostCloseControl$"
    *ngIf="operationStatus; else loader"
    avi-tooltip
    class="avi-health-score"
>
    <div class="sel-avi-healthscore avi-health-score__outer {{ healthScoreClass }}">
        <div
            *ngIf="isWafPolicyAvailable && !isWafPolicyInEvaluationMode"
            class="avi-health-score__waf-health-status"
        ></div>
        <div
            *ngIf="isWafPolicyInEvaluationMode"
            class="avi-health-score__waf-health-status-dotted"
        ></div>

        <span
            *ngIf="showDeactivatedIcon"
            class="avi-health-score__icon--deactivated"
        ></span>

        <i
            *ngIf="showExclamation"
            class="icon icon-exclamation avi-health-score__icon--exclamation"
        ></i>

        <ng-template #aviTooltipContent>
            <signpost
                class="avi-health-score__signpost"
                [signpostPosition]="signpostPosition"
                (onCloseButtonClick)="closeSignpost()"
                (mouseenter)="cancelCloseSignpost()"
                (mouseleave)="handleHealthScoreMouseLeave()"
            >
                <!-- Health Score Title -->
                <h3 class="avi-health-score__title">
                    <div class="sel-avi-healthscore avi-health-score__outer {{ healthScoreClass }}">
                        <span
                            *ngIf="isHealthScoreValueAvailable"
                            class="avi-health-score__health-score-count"
                        >
                            {{ runTime.health_score.health_score || 0 }}
                        </span>
                    </div>
                    <div
                        *ngIf="isWafPolicyAvailable"
                        class="avi-health-score__waf-status"
                        [ngClass]="{'avi-health-score__waf-status--evaluation-mode': isWafPolicyInEvaluationMode}"
                    >
                        <cds-icon
                            shape="shield"
                            solid="true"
                            class="avi-health-score__waf-status__shield"
                        ></cds-icon>
                    </div>
                    <div class="avi-health-score__text">
                        {{ title }}
                    </div>
                </h3>

                <!-- Health Score Body -->
                <div class="avi-health-score__signpost--body">
                    <div class="avi-health-score__health-score-faults">
                        <avi-health-score-faults
                            *ngIf="parsedFaults.length"
                            [faults]="parsedFaults"
                            [isServiceEngine]="false"
                        ></avi-health-score-faults>
                    </div>

                    <!-- Health Score Loader -->
                    <div
                        class="avi-health-score__spinner"
                        *ngIf="currentViewToRender === healthScoreView.LOADING"
                    >
                        <ng-container *ngTemplateOutlet="loader"></ng-container>
                    </div>

                    <!-- Health Score Error -->
                    <ng-container *ngIf="currentViewToRender === healthScoreView.ERROR">
                        <avi-health-score-error (onRetryClick)="fetchHeathScoreData()"></avi-health-score-error>
                    </ng-container>

                    <!-- Health Score Body Content -->
                    <ng-container
                        *ngIf="currentViewToRender === healthScoreView.UP || currentViewToRender === healthScoreView.DOWN"
                    >
                        <div class="avi-health-score__health-title">
                            <div>
                                <cds-icon
                                    shape="heart"
                                    size="18"
                                    class="avi-health-score__health-title--icon"
                                ></cds-icon>
                                <span class="avi-health-score__health-title--label">
                                    {{ l10nKeys.healthBreakdownLabel | vtranslate }}
                                </span>
                            </div>
                            <div
                                *ngIf="currentViewToRender === healthScoreView.DOWN"
                                class="avi-health-score__health-title--not-available-label"
                            >
                                {{ globalL10nKeys.notAvailableLabel | vtranslate }}
                            </div>
                        </div>

                        <ng-container *ngIf="currentViewToRender === healthScoreView.UP">
                            <!-- avi Health Score Body Content -->
                            <avi-health-score-body
                                [objectName]="objectName"
                                [uuid]="uuid"
                                [poolId]="poolId"
                                [operationStatus]="operationStatus"
                                [healthScore]="runTime.health_score"
                                [limit]="limit"
                                [step]="step"
                                [appSecurity]="isWafPolicyAvailable"
                                [appSecurityStatus]="isWafPolicyInEvaluationMode ? (l10nKeys.evaluationModeLabel | vtranslate) : ''"
                            ></avi-health-score-body>

                            <!-- Avi Health Score Footer -->
                            <avi-health-score-footer
                                *ngIf="!hideViewHealthButton"
                                (onViewHealthClick)="handleViewHealthButtonClick()"
                            ></avi-health-score-footer>
                        </ng-container>

                        <ng-container *ngIf="currentViewToRender === healthScoreView.DOWN">
                            <!-- Avi Health Score Down Status -->
                            <avi-health-score-down
                                [stateLabel]="stateLabel"
                                [reasons]="reasons"
                            ></avi-health-score-down>
                        </ng-container>
                    </ng-container>
                </div>
            </signpost>
        </ng-template>
    </div>
</div>

<ng-template #loader>
    <clr-spinner [clrMedium]="true"></clr-spinner>
</ng-template>
